import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { OKTA_TOKEN_STORAGE_KEYS } from '@core/auth/okta-auth.constants';
import { environment } from '@environments/environment';
import OktaAuth from '@okta/okta-auth-js';
import { EXTERNAL_OKTA_AUTH } from './external-okta-auth.token';

export function provideExternalOktaAuth(): EnvironmentProviders {
  const externalOkta = environment.externalOkta;
  const issuer = externalOkta.issuer?.trim();
  const clientId = externalOkta.clientId?.trim();
  const redirectUri = externalOkta.redirectUri?.trim();
  const scopes =
    typeof externalOkta.scopes === 'string'
      ? externalOkta.scopes
          .split(',')
          .map((scope) => scope.trim())
          .filter((scope) => scope.length > 0)
      : [];

  if (!issuer || !clientId || !redirectUri) {
    return makeEnvironmentProviders([]);
  }

  return makeEnvironmentProviders([
    {
      provide: EXTERNAL_OKTA_AUTH,
      useFactory: () =>
        new OktaAuth({
          issuer,
          clientId,
          redirectUri,
          scopes,
          pkce: externalOkta.pkce !== 'false',
          // Isolate from internal Okta — shared okta-token-storage caused cross-flow renew hangs.
          tokenManager: {
            storageKey: OKTA_TOKEN_STORAGE_KEYS.external,
          },
          // OAuth transaction (PKCE verifier/state) must survive the full-page Okta
          // redirect used by company SSO. IDX stays in memory so password/MFA flows
          // do not pick up stale localStorage/cookie handles.
          storageManager: {
            transaction: {
              storageType: 'sessionStorage',
              storageTypes: ['sessionStorage'],
            },
            idx: {
              storageType: 'memory',
              storageTypes: ['memory'],
            },
          },
          transactionManager: {
            enableSharedStorage: false,
          },
          idx: {
            exchangeCodeForTokens: true,
          },
        }),
    },
  ]);
}
